// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-524c93dc]{width:100%;border-spacing:0}.list__head__title[data-v-524c93dc]{text-align:left;color:#c6c8cd;font-size:16px;font-weight:400;letter-spacing:.24px;border-bottom:1px solid #1c252f;padding-bottom:8px}@media(max-width:700px){.offers[data-v-524c93dc]{display:none}}.top-rank[data-v-524c93dc]{text-align:center}", ""]);
// Exports
module.exports = exports;
